/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MediaStrictHttpResponse } from '../../media-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyValueGuidModel } from '../../models/key-value-guid-model';

export interface MasterDataCategoryListGet$Plain$Params {
}

export function masterDataCategoryListGet$Plain(http: HttpClient, rootUrl: string, params?: MasterDataCategoryListGet$Plain$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<Array<KeyValueGuidModel>>> {
  const rb = new RequestBuilder(rootUrl, masterDataCategoryListGet$Plain.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MediaStrictHttpResponse<Array<KeyValueGuidModel>>;
    })
  );
}

masterDataCategoryListGet$Plain.PATH = '/MasterData/CategoryList';
